import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormInputTextStyles = makeStyles()((theme: Theme) => ({
	label: {
		marginBottom: theme.spacing(1),
		marginTop: 0,
		fontWeight: theme.typography.fontWeightMedium,
	},
	inputField: {
		height: theme.spacing(5),
	},
	inputMultiline: {
		padding: 0,
	},
	input: {
		padding: theme.spacing(1, 1.5),
		"&:disabled": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
	},
	count: { color: theme.palette.text.disabled },
	countMultiline: {
		alignSelf: "flex-start",
		marginTop: theme.spacing(1),
		marginRight: theme.spacing(1.75),
	},
}));
